module.exports = __webpack_public_path__ + "img/trash.e8ae5ee4.svg";